module.exports = __webpack_public_path__ + "img/pdf.520b2771.png";